export default __webpack_public_path__ + "static/media/Poppy_9781408300336.30104dc3.jpg";